export default class Trans
{
	constructor(res={})
	{
		this.plural = res.plural || ((n) => n !== 1);
		this.msgs   = res.msgs || {};
	}


	format(msg, args)
	{
		return msg.replace(/%%/g, "%% ")
			  .replace(/%(\d+)/g, (str, idx) => args[idx - 1])
			  .replace(/%% /g, "%");
	}


	gettext(id, ...args)
	{
		const msg = id in this.msgs ? this.msgs[id][0] : id;

		return args.length > 0 ? this.format(msg, args) : msg;
	}


	pgettext(ctx, id, ...args)
	{
		const key = ctx + "\x04" + id;
		const msg = key in this.msgs ? this.msgs[key][0] : id;

		return args.length > 0 ? this.format(msg, args) : msg;
	}


	ngettext(id, idp, n, ...args)
	{
		const num = Math.round(n);
		const idx = Math.round(this.plural(num));
		const msg = id in this.msgs && typeof this.msgs[id][idx] !== "undefined"
			? this.msgs[id][idx] : (num === 1 ? id : idp);

		args.unshift(n);

		return this.format(msg, args);
	}
}
